<div class="status-container mb-2">
  @if (['FINISHED', 'RESOLD'].includes(offerStatus)) {
    <span id="offer-buying.buy-success-message" class="ps-md-2 success">
      <ucs-icon [shape]="'feather/check'" [class]="'feather-green'" [size]="20"></ucs-icon>
      {{ 'buy-now.bought' | translate }}
    </span>
  }
</div>
